// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_TQX","cls2":"ExportFormatModal-cls2_fRF ExportFormatModal-cls1_TQX"};